<template>
<div>
  <app-header class="header"></app-header>
  <div class="purchase-content">
    <img :src="currentLan === 'zh_CN'? '../../static/images/purchase.png' : '../../static/images/purchase_en.png'" alt="">
  </div>
</div>
</template>

<script>
  import AppHeader from '@/components/header'
  import STORE_CONST from '../store/consts'

  export default{
    name: 'purchase',
    data () {
      return {
        currentLan: localStorage.getItem('currentLanguage')
      }
    },
    created () {
      console.log(this.currentLan)
      this.$store.dispatch(STORE_CONST.ACCOUNT.CURRENT).then(res => {
      }).catch(err => {
        if (this.$route.name !== 'login') {
          console.log('login path')
          this.$notify({
            message: this.$gettext(err.data.code),
            type: 'success'
          })
        } else {
          console.log('console', this.$route.name)
        }
      })
    },
    methods: {},
    components: {
      AppHeader
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
.purchase-content{
  img{
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// purchase.vue?0af610ae